export const EXTENSIBLE_API_STATES = ['current_user', 'drops'];
export const SET_PAIRS = 'SET_PAIRS';
export const SET_CURRENT_PAIR = 'SET_CURRENT_PAIR';
export const SET_USER_ASSETS = 'SET_USER_ASSETS';
export const SET_USER_PACKS = 'SET_USER_PACKS';
export const SET_USER_FRACPACKS = 'SET_USER_FRACPACKS';
export const SET_USER_WATCHLIST = 'SET_USER_WATCHLIST';
